import { defineComponent } from 'vue';
import { EnvCheckService } from '@/services/exam/envCheck.service';
import { useService } from '@kaokei/use-vue-service';
import { CaretRightOutlined } from '@ant-design/icons-vue';
export default defineComponent({
  name: 'UserEnvCheckStage1',
  components: {
    CaretRightOutlined: CaretRightOutlined
  },
  setup: function () {
    var envCheckService = useService(EnvCheckService);
    var startCheck = function () {
      envCheckService.stage = 2;
    };
    return {
      startCheck: startCheck
    };
  }
});